;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import clsx from 'clsx'
import { useRouter } from 'next/router'
import { SidebarLogoutButton } from 'src/deprecated/components/shared/templates/Sidebar/SidebarLogoutButton'
import { useUserContext } from 'src/deprecated/contexts/User'

import { SellerSidebar } from './SellerSidebar'
import { SidebarMyProfileButton } from './SidebarMyProfileButton'

type SidebarProps = {
  className?: string
  onClickRoute?: () => void
}

export function Sidebar({ className, onClickRoute }: SidebarProps) {
  const router = useRouter()
  const user = useUserContext()

  const getIsActive = (testPath: RegExp) => {
    if (!router.isReady) return false

    return testPath.test(router.asPath)
  }

  return (
    <div
      className={clsx(
        'font-outfit flex h-full flex-col justify-between overflow-y-auto',
        className,
      )}
    >
      <nav className="h-full flex-1 flex-col justify-between space-y-1 overflow-y-auto pt-6 md:pt-0">
        <SellerSidebar
          validateIsActiveLink={getIsActive}
          onClickRoute={onClickRoute}
        />
      </nav>

      <SidebarMyProfileButton
        isActive={getIsActive(/\/my-profile\//)}
        companyName={user?.company}
        onClickRoute={onClickRoute}
      />

      {user ? <SidebarLogoutButton /> : null}
    </div>
  )
}
